<div class="dialog-content-min">
    <form [formGroup]="credentialForm">
        <div class="formgrid grid m-1">
            <div class="field col-12">
                <label for="url">
                    URL Name
                    <span  style="color: rgb(60, 137, 246);font-size:10px !important; font-weight: bold;">(Max 200
                        chars)</span>
                    <span class="required-label" style="color: rgb(222,30,30); font-weight: bold;">*</span>
                </label>
                <textarea [autoResize]="true" class="form-control" pInputTextarea formControlName="url" id="url"
                    name="url" placeholder="Enter URL Name"></textarea>
                <span style="color:red"
                    *ngIf="credentialForm.get('url').invalid && (credentialForm.get('url').dirty || credentialForm.get('url').touched)">
                    {{ getErrorMessage(credentialForm, validation_message, 'url') }}
                </span>
            </div>

            <div class="field col-12">
                <label for="userid">
                    User ID
                    <span   style="color: rgb(60, 137, 246);font-size:10px !important; font-weight: bold;">(Max 50
                        chars)</span>
                    <span class="required-label" style="color: rgb(222,30,30); font-weight: bold;">*</span>
                </label>
                <input class="form-control" id="userid" name="userid" placeholder="Enter User ID"
                    formControlName="userid" />
                <span style="color:red"
                    *ngIf="credentialForm.get('userid').invalid && (credentialForm.get('userid').dirty || credentialForm.get('userid').touched)">
                    {{ getErrorMessage(credentialForm, validation_message, 'userid') }}
                </span>
            </div>

            <div class="field col-12">
                <label for="password">
                    Password
                    <span   style="color: rgb(60, 137, 246);font-size:10px !important; font-weight: bold;">(Max 30
                        chars)</span>
                    <span class="required-label" style="color: rgb(222,30,30); font-weight: bold;">*</span>
                </label>
                <div style="display:flex; align-items:center;">
                    <input class="form-control" [type]="showPass ? 'text' : 'password'" id="password" name="password"
                        placeholder="Enter Password" formControlName="password" />


                </div>
                <input type="checkbox" style="margin-left:10px;" (change)="showPass = !showPass" />
                <label style="margin-left:5px;">Show Password</label>
                <span style="color:red"
                    *ngIf="credentialForm.get('password').invalid && (credentialForm.get('password').dirty || credentialForm.get('password').touched)">
                    {{ getErrorMessage(credentialForm, validation_message, 'password') }}
                </span>
            </div>

            <div class="field col-12">
                <label for="description">
                    Description
                    <span   style="color: rgb(60, 137, 246);font-size:10px !important; font-weight: bold;">(Max 450
                        chars)</span>
                </label>
                <textarea [autoResize]="true" class="form-control" id="description" name="description"
                    placeholder="Enter Description" formControlName="description" pInputTextarea>
            </textarea>
                <span style="color:red"
                    *ngIf="credentialForm.get('description').invalid && (credentialForm.get('description').dirty || credentialForm.get('description').touched)">
                    {{ getErrorMessage(credentialForm, validation_message, 'description') }}
                </span>
            </div>
        </div>
    </form>
</div>

<div class="custom-dialog-footer">
    <p-button class="m-1" label="Close" styleClass="customeclose"
        (click)="closemodal(credentialForm, this.ref, 'Are you sure you want to close?')">
    </p-button>
    <p-button class="m-1" *ngIf="!onlyView" label="{{saveTitle}}" styleClass="customesave" (click)="saveCredential()">
    </p-button>
</div>